import {
  JackpotContextProvider,
  LocaleProvider,
  queryClient,
  SolanaProvider,
} from "@lobby/core/src/app";
import { PanicFrame } from "@lobby/core/src";
import {
  LobbySettingsContextProvider,
  PlayerSettingsContextProvider,
} from "@lobby/core/src/entities";
import { localesMap } from "@lobby/core/src/shared";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { Loader, Logo } from "shared/ui";
import { router } from "./config";

import "./index.css";

export function App() {
  // Set default EN locale if it's not set, or if locale in localStorage is not in localesMap,
  // due to the fact that it was removed from the app.
  const locale = localStorage.getItem("locale");
  if (!localesMap[locale as keyof typeof localesMap]) {
    localStorage.setItem("locale", "en");
  }

  return (
    <QueryClientProvider client={queryClient}>
      <PanicFrame>
        <LobbySettingsContextProvider Logo={Logo} Loader={Loader}>
          <PlayerSettingsContextProvider>
            <JackpotContextProvider>
              <LocaleProvider>
                <SolanaProvider>
                  <RouterProvider router={router} />
                </SolanaProvider>
              </LocaleProvider>
            </JackpotContextProvider>
          </PlayerSettingsContextProvider>
        </LobbySettingsContextProvider>
      </PanicFrame>
    </QueryClientProvider>
  );
}

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
